export const SESSION_TIMING=3;